import {
  doesSpecialApply,
  getSpecialIdsForTagLabel,
  getSpecialTagLabel,
} from '@iheartjane/menu';
import type {
  ComplianceLanguageSettings,
  Nullable,
  Nullish,
} from '@iheartjane/types';

import type { StoreSpecials } from '@jane/bloom/types/schemas/marketplace/storeSpecials';
import { getSpecialBadgeLabel } from '@jane/bloom/viewModels/getPrice';
import type { AlgoliaProduct } from '@jane/search/types';

interface GetSpecialLabelArgs {
  bundleTag: boolean;
  product: AlgoliaProduct;
  specials: Nullish<StoreSpecials>;
  storeComplianceLanguageSettings: Nullable<ComplianceLanguageSettings>;
}

export const getSpecialLabel = ({
  bundleTag,
  product,
  specials,
  storeComplianceLanguageSettings,
}: GetSpecialLabelArgs): string => {
  const applicableSpecial = bundleTag
    ? specials
        ?.filter(Boolean)
        .find((special) =>
          doesSpecialApply(
            getSpecialIdsForTagLabel(product),
            special.id,
            special.special_type
          )
        )
    : undefined;

  const label = bundleTag
    ? applicableSpecial
      ? getSpecialTagLabel({
          product,
          store: {
            store_compliance_language_settings: storeComplianceLanguageSettings,
          },
        })
      : ''
    : getSpecialBadgeLabel(product, storeComplianceLanguageSettings);

  return label ?? '';
};
